module.exports = __webpack_public_path__ + "img/cureIncomeSecond.0473195c.svg";